import React, { useRef, useState } from "react";
import { Form, Input, Image } from "antd";
import EyeOpen from "../../../../assets/images/eye-open.svg";
import EyeClose from "../../../../assets/images/eye-close.svg";
import { useTranslation } from "react-i18next";

const CustomInput = ({ label, name, type, placeholder, rules }) => {
  const { t } = useTranslation();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const inputRef = useRef(null);

  const togglePasswordVisibility = () => {
    const { selectionStart, selectionEnd } = inputRef.current.input;
    setPasswordVisible(!passwordVisible);
    setTimeout(() => {
      inputRef.current.input.setSelectionRange(selectionStart, selectionEnd);
      inputRef.current.focus();
    }, 0);
  };

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Input
        ref={inputRef}
        type={passwordVisible ? "text" : type}
        placeholder={placeholder}
        suffix={
          type === "password" &&
          (passwordVisible ? (
            <Image
              preview={false}
              src={EyeOpen}
              alt={t("hidePassword")}
              onClick={togglePasswordVisibility}
            />
          ) : (
            <Image
              preview={false}
              src={EyeClose}
              alt={t("showPassword")}
              onClick={togglePasswordVisibility}
            />
          ))
        }
      />
    </Form.Item>
  );
};

export default CustomInput;
